export * from 'fp-ts-std/Number';
export * from 'fp-ts/number';
export var fromBoolean = function (x) { return (x ? 1 : 0); };
export var floor = Math.floor;
export var ceil = Math.ceil;
